import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { useBooleanFlagValue } from '@openfeature/react-sdk'

import ErrorFallback from 'components/ErrorFallback'

import UserForm from './Form'
import UserFormHooks from './Form.hooks'

export default function UserFormWrapper(props) {
  const enabled = useBooleanFlagValue('form-user-hooks', false)

  return enabled ? (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <UserFormHooks {...props} />
    </ErrorBoundary>
  ) : (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <UserForm {...props} />
    </ErrorBoundary>
  )
}
